import { render, staticRenderFns } from "./typingRegister.vue?vue&type=template&id=c40d7812&scoped=true&"
import script from "./typingRegister.vue?vue&type=script&lang=js&"
export * from "./typingRegister.vue?vue&type=script&lang=js&"
import style0 from "./typingRegister.vue?vue&type=style&index=0&lang=less&"
import style1 from "./typingRegister.vue?vue&type=style&index=1&id=c40d7812&lang=less&scoped=true&"
import style2 from "./typingRegister.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40d7812",
  null
  
)

export default component.exports